const relayPointMarkerContent = (relayPoint, submitButton, carrierIconName, t) => {
  return `<div class="w-100">
      <div class="d-flex justify-content-between align-items-center gap-2 w-100">
        <p class="m-0 font-weight-bold">${relayPoint.name}</p>
        ${
          relayPoint.carrier_name !== "chronopost"
            ? `<img
          src="/images/${process.env.NEXT_PUBLIC_CUSTOMER}/${carrierIconName}.png"
          alt="${relayPoint.name} logo"
          style="width: 24px; height: 24px; object-fit: contain;"
        />`
            : ""
        }
      </div>
      <p class="my-1">${relayPoint.line1}</p>
      ${relayPoint.line2 ? `<p class="my-1">${relayPoint.line2}</p>` : ""}
      <p class="mt-1 mb-2">${relayPoint.zip} ${relayPoint.city}, ${relayPoint.country}</p>
      <div>
        <div class="d-flex">
          <p class="relay-points-opening-day">${t(`days_of_week.monday`)}</p>
          <p class="relay-points-opening-hours">
            ${(relayPoint.opening_hours.monday || "closed") === "closed" ? t("closed") : relayPoint.opening_hours.monday}
          </p>
        </div>
        <div class="d-flex">
          <p class="relay-points-opening-day">${t(`days_of_week.tuesday`)}</p>
          <p class="relay-points-opening-hours">
            ${(relayPoint.opening_hours.tuesday || "closed") === "closed" ? t("closed") : relayPoint.opening_hours.tuesday}
          </p>
        </div>
        <div class="d-flex">
          <p class="relay-points-opening-day">${t(`days_of_week.wednesday`)}</p>
          <p class="relay-points-opening-hours">
            ${(relayPoint.opening_hours.wednesday || "closed") === "closed" ? t("closed") : relayPoint.opening_hours.wednesday}
          </p>
        </div>
        <div class="d-flex">
          <p class="relay-points-opening-day">${t(`days_of_week.thursday`)}</p>
          <p class="relay-points-opening-hours">
            ${(relayPoint.opening_hours.thursday || "closed") === "closed" ? t("closed") : relayPoint.opening_hours.thursday}
          </p>
        </div>
        <div class="d-flex">
          <p class="relay-points-opening-day">${t(`days_of_week.friday`)}</p>
          <p class="relay-points-opening-hours">
            ${(relayPoint.opening_hours.friday || "closed") === "closed" ? t("closed") : relayPoint.opening_hours.friday}
          </p>
        </div>
        <div class="d-flex">
          <p class="relay-points-opening-day">${t(`days_of_week.saturday`)}</p>
          <p class="relay-points-opening-hours">
            ${(relayPoint.opening_hours.saturday || "closed") === "closed" ? t("closed") : relayPoint.opening_hours.saturday}
          </p>
        </div>
        <div class="d-flex">
          <p class="relay-points-opening-day">${t(`days_of_week.sunday`)}</p>
          <p class="relay-points-opening-hours">
            ${(relayPoint.opening_hours.sunday || "closed") === "closed" ? t("closed") : relayPoint.opening_hours.sunday}
          </p>
        </div>
      </div>
      ${submitButton ? `<button type="button" class="btn btn-primary w-100 mt-2" onclick="document.querySelector('#save-relay-point').click()">${t("shipping_form.choose_relay_point")}</button>` : ""}
    </div>`;
};

export default relayPointMarkerContent;
